import { PropType } from '@vue/composition-api';

export default {
  visible: Boolean,
  iframeUrl: {
    type: String,
    default: '',
  },
  width: String,
  isRtl: Boolean,
  maskZIndex: {
    type: Number,
    default: 200,
  },
  // 抽屉顶部距离
  drawerTop: {
    type: String,
  },
  lang: {
    type: String,
    default: 'en',
  },
  isAthenaCallerReady: {
    type: Boolean,
    default: false,
  },
  iframeStyle: {
    type: Object,
    default: () => ({}),
  },
  extEventNameList: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  initData: {
    type: Object as PropType<Record<string, unknown>>,
    default: () => ({}),
  },
  getInitData: {
    type: Function as PropType<() => Promise<Record<string, unknown>>>,
  },
  permanentMode: {
    type: Boolean,
    default: false,
  },
};
